export default "__VITE_ASSET__Bme0ZAxe__"